
export { IS_MAIN_BRANCH } from "/vercel/path0/libs/constants/src/lib/environments.ts"
export { IS_VERCEL_PROD } from "/vercel/path0/libs/constants/src/lib/environments.ts"
export { PROD_DOMAIN } from "/vercel/path0/libs/constants/src/lib/environments.ts"
export { STAGING_DOMAIN } from "/vercel/path0/libs/constants/src/lib/environments.ts"
export { VERCEL_BRANCH_URL } from "/vercel/path0/libs/constants/src/lib/environments.ts"
export { minisiteOriginBySlug } from "/vercel/path0/libs/constants/src/lib/index.ts"